/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cat_Kargo_TitleInputs */

const tr_faq_cat_kargo_title = /** @type {(inputs: Faq_Cat_Kargo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kargo ve Teslimat`)
};

const en_faq_cat_kargo_title = /** @type {(inputs: Faq_Cat_Kargo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery & Labels`)
};

const de_faq_cat_kargo_title = /** @type {(inputs: Faq_Cat_Kargo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versand und Etiketten`)
};

const ru_faq_cat_kargo_title = /** @type {(inputs: Faq_Cat_Kargo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка и этикетки`)
};

/**
* | output |
* | --- |
* | "Delivery & Labels" |
*
* @param {Faq_Cat_Kargo_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_cat_kargo_title = /** @type {((inputs?: Faq_Cat_Kargo_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cat_Kargo_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_cat_kargo_title(inputs)
	if (locale === "de") return de_faq_cat_kargo_title(inputs)
	if (locale === "ru") return ru_faq_cat_kargo_title(inputs)
	return tr_faq_cat_kargo_title(inputs)
});